import React from 'react';
import cn from 'classname';
import './index.less';

import get from 'lodash/get';

import { connect } from 'react-redux';

import { Link } from 'react-router';

function CustomizableBlock({
	className, tag: Tag = 'div', top = 0, isDisplayAllowed, isHintAllowed, settingId, children,
	isHidden = false
}) {
	if (isHidden) {
		return null;
	}
	return (typeof children === 'function' || isDisplayAllowed) && (
		<Tag className={cn('customizable-block', className)}>
			{typeof children !== 'function' ? children : children(isDisplayAllowed)}

			{isHintAllowed && (
				<Link
					className='customizable-block-hint'
					style={{ top }}
					to={`/profile#${settingId}`}
					title='Hide ?'
				>
          *
				</Link>
			)}
		</Tag>
	);
}

export default connect(
	(state, props) => {
		const hidden_items = get(state, 'root.data.settings.hidden_items') || [];

		return {
			isDisplayAllowed: !hidden_items.includes(props.settingId),
			isHintAllowed: props.isHintAllowed !== undefined ? props.isHintAllowed : !hidden_items.includes('settings-hints')
		};
	}
)(CustomizableBlock);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/customizable-block/index.js